export default __webpack_public_path__ + "static/media/a4.237b138c.png";